module.exports = __webpack_public_path__ + "static/media/Sanomat Grab Web-Regular Italic TH.57a4d38c.eot";